import { h } from 'preact'
import Icon from '../assets'

export type Props = {
  name: string
  count?: number,
  isDismissable?: boolean,
  onClick?: () => void
}

const FilterPill = ({
  name,
  count,
  isDismissable,
  onClick = () => {}
} : Props) => (
  <li className='filter-list-pill'>
    <span>{name}</span>
    {
      count && <span className='filter-count'> {count} </span>
    }
    {
      isDismissable && <Icon onClick={onClick} icon='close' width={16} height={16} color={'#fff'} />
    }
  </li>
)

export default FilterPill
